export const HCAPTCHA_KEY = '4c06a02d-4657-4f09-89d8-a6eb83b3a244'
export const API_URL = 'https://web-production-d361.up.railway.app'
// dev 
// const apiUrl = 'http://localhost:3001'
// const HCAPTCHA_KEY = '10000000-ffff-ffff-ffff-000000000001'
